import { useQuery } from '@tanstack/react-query';
import type { ResourceApproval } from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';

export enum RefundStatusFilter {
  All = 'all',
  InProgress = 'in_progress',
  Finalized = 'finalized',
}

interface SearchParams {
  searchParams?: {
    status: RefundStatusFilter;
    page: string;
    per_page: string;
    identifier?: string;
    order?: string;
  };
}

interface ResourceApprovalsResponse {
  resource_approvals: ResourceApproval[];
  metadata: {
    total_pages: number;
  };
}

export const useResourceApprovalsIndex = ({ searchParams }: SearchParams) => {
  const response = useQuery<ResourceApprovalsResponse>({
    queryKey: [clientKeys.useResourceApprovalsIndex, searchParams],
    queryFn: async () =>
      await falconClient.get(
        `${baseUrl}/resource_approvals?${new URLSearchParams(searchParams)}`
      ),
  });

  const resourceApprovals = response.data?.resource_approvals || [];
  const totalPages = response.data?.metadata.total_pages || 0;

  return {
    resourceApprovals,
    totalPages,
    ...response,
  };
};
